// extracted by mini-css-extract-plugin
module.exports = {"theme":"#FA5D50"};